export const NO_STAR_RATING_VALUE = '0';

export const STARS_VALUES = ['5', '4', '3', '2', '1'];

export const EVO_STARS_VALUES = ['5', '4', '3'];
